import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Text } from '@awaze/design-system.components.text';
import { Stack } from '@awaze/design-system.components.stack';
import { breakpoints } from '@awaze/design-system.utils.react';
export const FooterTerms = ({ companyInformation, termsAndConditions, }) => {
    return (_jsxs(Stack, { direction: ['column', 'row', 'row'], justify: "space-between", align: ['normal', 'flex-end', 'flex-end'], children: [_jsx(Text, { as: "div", sizes: [100, 200, 200], "data-testid": "terms", children: companyInformation }), _jsx(Text, { sizes: [100, 200, 200], children: _jsx(StyledBookingTerms, { href: termsAndConditions.href, target: termsAndConditions.href ? '_blank' : '', children: termsAndConditions.displayText }) })] }));
};
export const StyledBookingTerms = styled.a `
  color: ${({ theme }) => theme.ColorWhiteOpacity100};
  text-decoration: none;
  text-align: left;
  @media (min-width: ${breakpoints[0]}px) {
    text-align: right;
  }
`;
//# sourceMappingURL=footer-terms.js.map